import type { Mission } from '../missions.ts'

export const uscourts: Mission = {
  id: "uscourts",
  name: "Administrative Office of the U.S. Courts",
  short: "U.S. Courts",
  call: "Judiciary",
  kind: "independent",
  url: "https://www.uscourts.gov/",
  established: 1939,
  palette: {
    primary: "#0057a3",
    secondary: "#002045",
    accent: "#dfa611",
  },
  colorSource: {
    kind: "site",
    url: "https://www.uscourts.gov/",
  },
  motif: "scales",
  mission: {
    text: "The Administrative Office is the agency within the judicial branch that provides a broad range of legislative, legal, financial, technology, management, administrative, and program support services to federal courts.",
    url: "https://www.uscourts.gov/administration-policies/judicial-administration",
  },
  fact: {
    text: "Congress established the Administrative Office in 1939 as the first judicial administrative agency to operate under the direction of federal judges rather than officers of the executive branch.",
    url: "https://www.fjc.gov/history/administration/administrative-bodies-administrative-office-us-courts-1939-present",
  },
  seal: {
    file: "public/seals/uscourts.png",
    source: "https://commons.wikimedia.org/wiki/File:US-Courts-AdministrativeOffice-Seal.svg",
  },
  identifier: {
    about: "https://www.uscourts.gov/administration-policies/judicial-administration",
    performance: "https://www.uscourts.gov/data-news/reports/strategic-planning",
    privacy: "https://www.uscourts.gov/privacy-security-policy",
  },
  media: {
    photos: [
      {
        file: "/media/uscourts-marshall-atrium.jpg",
        small: "/media/uscourts-marshall-atrium-sm.jpg",
        alt: "The glass-roofed atrium of the Thurgood Marshall Federal Judiciary Building, with a grove of bamboo and trees beneath a lattice skylight.",
        title: "Atrium of the Thurgood Marshall Federal Judiciary Building, Washington, D.C.",
        creator: "Architect of the Capitol",
        source: "https://commons.wikimedia.org/wiki/File:Atrium,Thurgood_Marshall_Building_in_Washington_D.C.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/uscourts-marshall-building.jpg",
        small: "/media/uscourts-marshall-building-sm.jpg",
        alt: "The granite and glass entrance of the Thurgood Marshall Federal Judiciary Building, with a tall glass atrium wall between two stone wings.",
        title: "Thurgood Marshall Federal Judiciary Building, Washington, D.C., October 15, 2016",
        creator: "Ron Cogswell",
        source: "https://commons.wikimedia.org/wiki/File:Thurgood_Marshall_Federal_Judiciary_Building_1_Columbus_Circle_NE_Washington_(DC)_2016_(30398337115).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
